export default {"src":"/_next/static/media/mail.c003757b.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};